<template>
    <sa-page-layout :pathResource="pathResource" :btnRefreshVisible="true" :viewFilterSection="false" :contentBodyHeader="false" :showModalLoading="showModalLoading" @refresh="onRefresh">
        <template slot="toolbar-title">
            <paziente-anagrafica v-if="idPaziente" :linkPatient="linkPatient" :idPaziente="idPaziente" @getAnagraficaPaziente="onGetAnagraficaPaziente"></paziente-anagrafica>
        </template>

        <template slot="toolbar">
            <b-button v-if="canInsert" class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" :disabled="!idPaziente" @click="onAdd">
                <b-icon icon="plus"></b-icon>
                Aggiungi
            </b-button>
        </template>

        <template slot="table-body">
            <paziente-parametri-vitali-list-component ref="parametriVitaliList" :idPaziente="idPaziente" @loading="onLoading"></paziente-parametri-vitali-list-component>
            <paziente-parametri-vitali-modal-edit-component ref="parametriVitaliModal" :idPaziente="idPaziente" @onSaveMisurazione="onSaveMisurazione"></paziente-parametri-vitali-modal-edit-component>
        </template>
    </sa-page-layout>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import PazienteAnagrafica from "../../components/PazienteAnagrafica.vue";
import PazienteParametriVitaliListComponent from "../components/PazienteParametriVitaliListComponent.vue";
import PazienteParametriVitaliModalEditComponent from "../components/PazienteParametriVitaliModalEditComponent.vue";

export default {
    components: {
        SaPageLayout,
        PazienteAnagrafica,
        PazienteParametriVitaliListComponent,
        PazienteParametriVitaliModalEditComponent,
    },
    mixins: [UtilityMixin],
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    data() {
        return {
            pathResource: "/pazientemisure",
            showModalLoading: false,
        };
    },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente ? String(this.$route.query.idPaziente) : null;
        },
        linkPatient() {
            return this.utente ? UtilityMixin.methods.getLinkPatient(this.utente, this.idPaziente) : "";
        },
        canInsert() {
            return UtilityMixin.methods.verificaPermessi(this.utente, "pazientemisure", 2);
        },
    },
    methods: {
        onAdd() {
            if (this.canInsert && this.idPaziente) {
                this.$refs.parametriVitaliModal.show();
            }
        },
        onRefresh() {
            if (this.$refs.parametriVitaliList) {
                this.$refs.parametriVitaliList.loadData();
            }
        },
        onSaveMisurazione() {
            this.onRefresh();
        },
        onLoading(value) {
            this.showModalLoading = value;
        },
        onGetAnagraficaPaziente(data) {
            console.log(data);
        },
    },
};
</script>
